"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformMailgunErrorToEmailFailureType = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const testingPairs = [
    [[/spam/i, /complained/i, /fraud/i, /rich relative from nigeria/i, /abusive/i], legacy_enums_1.AutomaticEmailFailureType.Spam],
    [[/bounce/i], legacy_enums_1.AutomaticEmailFailureType.Bounce],
    [[/invalid/i, /user unknown/i, /this user doesn't have .+ account/i], legacy_enums_1.AutomaticEmailFailureType.Invalid],
    [
        [
            /unavailable/i,
            /insufficient system resources/i,
            /error in processing/i,
            /quota exceeded/i,
            /failure/i,
            /server [a-z]*\s?error/i,
        ],
        legacy_enums_1.AutomaticEmailFailureType.Server,
    ],
    [[/mx/i], legacy_enums_1.AutomaticEmailFailureType.DNS],
    [[/timeout/i], legacy_enums_1.AutomaticEmailFailureType.Timeout],
];
function transformMailgunErrorToEmailFailureType(errorMessage) {
    for (const testingPair of testingPairs) {
        // iterate over every regexp in pair until
        // it's found in error message
        for (const rx of testingPair[0]) {
            if (rx.test(errorMessage)) {
                return testingPair[1];
            }
        }
    }
    return legacy_enums_1.AutomaticEmailFailureType.Unknown;
}
exports.transformMailgunErrorToEmailFailureType = transformMailgunErrorToEmailFailureType;
//# sourceMappingURL=transformMailgunErrorToEmailFailureType.js.map